/*
 * @Author: along longwang6@163.com
 * @Date: 2025-02-19 14:26:43
 * @LastEditors: along longwang6@163.com
 * @LastEditTime: 2025-06-14 16:59:20
 * @FilePath: /ehr-web/src/store/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE,
 */
import React, { useContext } from 'react';
import User from './modules/user';
import SystemConfig from '@/store/modules/systemConfig';
import UserHunter from '@/store/modules/userHunter';
import TabStore from '@/store/modules/tab';

const store = {
  user: new User(),
  systemConfig: new SystemConfig(),
  userHunter: new UserHunter(),
  tab: new TabStore(),
} as const;
const StoreContext = React.createContext(store);

const useStore = <T extends keyof typeof store>(storeKey: T) => {
  const store = useContext(StoreContext);
  return store[storeKey];
};

export { store, StoreContext, useStore };
